<template>
  <QIcon :class="`filter-icon ${isDirectionUpward && 'rotate'}`" :color="color" :size="size">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1)">
      <path d="M7 11h10v2H7zM4 7h16v2H4zm6 8h4v2h-4z"></path>
    </svg>
  </QIcon>
</template>

<script>
import { QIcon } from 'quasar';
export default {
  name: 'FilterIcon',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    color: {
      type: String
    },
    size: {
      type: String
    }
  },
  data() {
    return {
      isDirectionUpward: this.value
    };
  },
  watch: {
    value(newValue) {
      this.isDirectionUpward = newValue;
    },
    isDirectionUpward(value) {
      this.$emit('input', value);
    }
  },
  components: { QIcon }
};
</script>
<style lang="sass" scoped>
.filter-icon
  cursor: pointer
  font-size: 24px
  color: #333
  transition: transform 0.5s ease
  &.rotate
    transform: rotate(180deg)
</style>
